<template>
  <div class="row">
    <div class="col-12">
      <card card-body-classes="table-full-width px-4 pb-3" no-footer-line>

        <el-collapse accordion>
          <el-collapse-item name="1" :title="$t('app.modules.dashboard.orders.search')">
            <div class="card-body col-12 row">
              <!-- Buscar Número Pedido -->
              <div class="col-md-4 col-12 row">
                <div class="col-form-label col-12">{{ $t("app.modules.orders.headers.order_number") }}</div>
                <div class="col-12">
                  <fg-input>
                    <el-input
                      type="text"
                      class="mb-2 w-100"
                      clearable
                      style="width: 200px"
                      :placeholder="$t('app.modules.orders.headers.order_number')"
                      v-model="searchNumPedido"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </fg-input>
                </div>
              </div>
              <!-- Buscar Razón Social -->
              <div class="col-md-4 col-12 row">
                <div class="col-form-label col-12">{{$t("app.modules.orders.headers.business_name")}}</div>
                <div class="col-12">
                  <fg-input>
                    <el-input
                      type="text"
                      class="mb-2 w-100"
                      clearable
                      style="width: 200px"
                      :placeholder="$t('app.modules.orders.headers.business_name')"
                      v-model="searchRazonSocial"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </fg-input>
                </div>
              </div>
              <!-- Status Pedido -->
              <div class="col-md-4 col-12 row">
                <div class="col-form-label col-12">{{ $t("app.modules.orders.headers.status") }}</div>
                <div class="col-12">
                  <el-select
                    class="select-primary w-100"
                    size="large"
                    filterable
                    clearable
                    v-model="currState"
                    :placeholder="$t('app.modules.orders.headers.status')"
                  >
                    <el-option label="Todos" value=""></el-option>
                    <el-option
                      v-for="item in this.status"
                      :key="item.idEstadoPedido"
                      :label="item.estadoPEdido"
                      :value="item.estadoPEdido"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!-- Status Pedido
              <div class="col-md-4 col-12 row">
                <div class="col-form-label col-12">{{ $t("app.modules.orders.headers.order_number") }}</div>
                <div class="col-12">
                  <input type="text" class="form-control" :placeholder="$t('app.modules.orders.headers.order_number')" >
                </div>
              </div>
              <div class="col-md-4 col-12 row">
                <div class="col-form-label col-12">{{ $t("app.modules.orders.headers.order_number") }}</div>
                <div class="col-12">
                  <input type="text" class="form-control" :placeholder="$t('app.modules.orders.headers.order_number')" >
                </div>
              </div>
              <div class="col-md-4 col-12 row">
                <div class="col-form-label col-12">{{ $t("app.modules.orders.headers.order_number") }}</div>
                <div class="col-12">
                  <input type="text" class="form-control" :placeholder="$t('app.modules.orders.headers.order_number')" >
                </div>
              </div>
              <div class="col-md-4 col-12 row">
                <div class="col-form-label col-12">{{ $t("app.modules.orders.headers.order_number") }}</div>
                <div class="col-12">
                  <input type="text" class="form-control" :placeholder="$t('app.modules.orders.headers.order_number')" >
                </div>
              </div>
              -->
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>
    </div>
    <div class="col-12">
      <card ccard-body-classes="table-full-width px-4 pb-3" no-footer-line>
        <div>
          <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <h4 class="card-title text-purple">
              {{ $t("app.modules.orders.title") }}
            </h4>
          </div>

          <el-table stripe style="width: 100%" :data="queriedData">
            <el-table-column
              :label="$t('app.modules.orders.headers.created_date')"
              min-width="200"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.fechaCreacionPedido }}
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('app.modules.orders.headers.auth_date')"
              min-width="200"
              sortable
            >
              <template slot-scope="scope">
                {{
                  scope.row.fechaConfirmacionPedido == "1900-01-01"
                    ? ""
                    : scope.row.fechaConfirmacionPedido
                }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('app.modules.orders.headers.order_number')"
              min-width="200"
              sortable>
              <template slot-scope="scope">
                {{ scope.row.numPedidoSAP }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('app.modules.orders.headers.status')"
              min-width="200"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.estadoPedido }}
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('app.modules.orders.headers.business_name')"
              min-width="200"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.razonSocial }}
              </template>
            </el-table-column>
            <el-table-column width="200">
              <div slot-scope="props" class="table-actions dropdown">
                <el-popover
                  placement="bottom"
                  width="300"
                  trigger="click"
                  :ref="'refOption' + props.$index"
                >
                  <div class="row">
                    <div class="col-12 options">
                      <n-button
                        v-if="props.row.idEstadoPedido == constEstadoPedido.PROCESOERNTREGA"
                        @click.native="
                          showTracking(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.modules.orders.tracking.name") }}
                      </n-button>
                      <n-button v-if="props.row.idEstadoPedido !== constEstadoPedido.INICIAL"
                                @click.native="resendConfirmation(props.row)"
                                class="options-button"
                                type="primary"
                                size="sm"
                      >
                        {{ $t("app.modules.orders.form.resend_order") }}
                      </n-button>
                      <n-button
                        @click.native="record(props.row)"
                        class="options-button"
                        type="primary"
                        size="sm"
                      >
                        {{ $t("app.modules.orders.form.record") }}
                      </n-button>
                      <!--<n-button v-if="props.row.idEstadoPedido !== constEstadoPedido.DEVUELTO_VALIDACION
                        && props.row.idEstadoPedido !== constEstadoPedido.DECLINADO"
                        @click.native="returnOrder(props.row)"
                        class="options-button"
                        type="primary"
                        size="sm"
                      >
                        {{ $t("app.modules.orders.form.return_order") }}
                      </n-button>
                      <n-button
                        v-if="props.row.idEstadoPedido !== constEstadoPedido.DECLINADO"
                        @click.native="cancelOrder(props.row)"
                        class="options-button"
                        type="primary"
                        size="sm"
                      >
                        {{ $t("app.modules.orders.form.cancel_order") }}
                      </n-button>-->
                      <n-button
                        @click.native="
                          showDocs(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.modules.orders.documents.single") }}
                      </n-button>
                      <n-button
                        @click.native="
                          showDetails(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.modules.orders.details.single") }}
                      </n-button>
                    </div>
                  </div>
                  <n-button
                    slot="reference"
                    size="sm"
                    icon
                    class="button-options-table"
                  >
                    <i class="fa fa-ellipsis-v" style="color:black;"></i>
                  </n-button>
                </el-popover>
              </div>
            </el-table-column>
          </el-table>
        </div>

        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class="">
            <p class="card-category">
              {{ $t("app.pagination.showing") }} {{ from + 1 }}
              {{ $t("app.pagination.of") }} {{ to }}
              {{ $t("app.pagination.of") }} {{ total }}
              {{ $t("app.pagination.records") }}
            </p>
          </div>

          <n-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </n-pagination>
        </div>
      </card>
    </div>
    <devolver-pedido-modal />
    <historial-pedido-modal />
  </div>
</template>

<script>
import DevolverPedidoModal from "../pedidos/devolverPedidoModal";
import HistorialPedidoModal from "../pedidos/historialPedidoModal";
import ConstEstadoPedido from "@/models/pedidos/ConstEstadoPedido";
import {getResponse} from "@/util/utilities";
export default {
  name: "BusquedaDePedidos",
  components: {
    DevolverPedidoModal,
    HistorialPedidoModal
  },
  computed: {
    queriedData() {
      let result = this.tableData;
      // filter by create date
      result =
        this.iniCreateDate > new Date("1900-01-01") &&
        this.endCreateDate > new Date("1900-01-01")
          ? (result = result.filter(
          d =>
            new Date(d.fechaCreacionPedido) >= this.iniCreateDate &&
            new Date(d.fechaCreacionPedido) <= this.endCreateDate
          ))
          : result;

      // filter by confirmation date
      result =
        this.iniAuthDate > new Date("1900-01-01") &&
        this.endAuthDate > new Date("1900-01-01")
          ? (result = result.filter(
          d =>
            (new Date(d.fechaConfirmacionPedido) >= this.iniAuthDate &&
              new Date(d.fechaConfirmacionPedido) <= this.endAuthDate) ||
            d.fechaConfirmacionPedido == "1900-01-01"
          ))
          : result;

      // filter by business name
      result =
        this.searchRazonSocial.length > 0
          ? result.filter(d => d.razonSocial.includes(this.searchRazonSocial))
          : result;

      // filter by order number
      result =
        this.searchNumPedido.length > 0
          ? result.filter(d => d.numPedidoSAP.includes(this.searchNumPedido))
          : result;

      // filter by salesman
      result =
        this.searchSalesman.length > 0
          ? result.filter(d => d.nombre.includes(this.searchSalesman))
          : result;

      // filter by customer service
      result =
        this.searchCS.length > 0
          ? result.filter(d =>
            d.nombreUsuarioServicioCliente.includes(this.searchCS)
          )
          : result;

      // filter by status
      result =
        this.currState.length > 0
          ? result.filter(d => d.estadoPedido.includes(this.currState))
          : result;

      // filter by client id SAP
      result =
        this.currClient != 0
          ? result.filter(d => d.idClienteSAP == this.currClient)
          : result;

      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      currState: "",
      currClient: "",
      tableData: [],
      searchQuery: "",
      searchNumPedido: "",
      searchRazonSocial: "",
      searchSalesman: "",
      searchCS: "",
      searchedData: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      createDate: new Date(2020, 1, 1),
      iniCreateDate: new Date(2020, 1, 1),
      endCreateDate: new Date(2020, 12, 1),
      authDate: new Date(2020, 1, 1),
      iniAuthDate: new Date(2020, 1, 1),
      endAuthDate: new Date(2020, 12, 1),
      status: [],
      clientes: [],
      constEstadoPedido: new ConstEstadoPedido()
    };
  },
  async mounted() {
    this.init();
    EventBus.$on("reload-items", () => {
      this.init();
    });
  },
  methods: {
    async init() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.getStatus();
      await this.getItems();
      await this.getClients();
      this.$swal.close();
    },
    async getStatus() {
      await this.$http.get(route("Pedidos/getEstadosPedido")).then(
        response => {
          if (response.body.code === 200) {
            this.status = response.body.estados;
          } else {
            console.log(response.body);
            // this.processError(response.body)
          }
        },
        error => {
          console.error(error);
          // this.processError(error)
        }
      );
    },
    async getItems() {
      const params = {
        Id: 0,
        ClaveIdioma: this.$store.state.lang,
        Usuario: 0,
        Estado: 0
      };

      await this.$http.post(route("Pedidos/dashboardListaPedidos"), params).then(
        response => {
          if (response.body.code === 200) {
            this.tableData = response.body.pedidos;
          } else {
            console.log(response.body);
            // this.processError(response.body)
          }
        },
        error => {
          console.error(error);
          // this.processError(error)
        }
      );
    },
    returnOrder(row) {
      EventBus.$emit("devolverPedido", row);
    },
    cancelOrder(row) {
      EventBus.$emit("declinarPedido", row);
    },
    record(row) {
      EventBus.$emit("historialPedido", row);
    },
    async resendConfirmation(row) {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      let data = new FormData();
      data.append("idPedido", row.idPedido);

      let request = await this.$http.post(
        route("Pedidos/enviarPedidoConfirmacion"),
        data
      );
      let response = getResponse(request);

      if (response) {
        this.init();
        this.notifyMessage("success", this.$t("app.promps.save_success"));
      } else this.notifyMessage("danger", this.$t("app.promps.error"));

      this.$swal.close();
    },
    async getClients() {
      const params = {
        Id: 0,
        ClaveIdioma: this.$store.state.lang,
        Usuario: 0,
        Estado: 0
      };

      await this.$http.get(route("Clientes/getClientes")).then(
        response => {
          if (response.body.code === 200) {
            this.clientes = response.body.clientes;
          } else {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        },
        error => {
          this.notifyMessage("danger", this.$t("app.promps.error"));
        }
      );
    },
    showDocs(index, row, ref) {
      this.$refs[ref].doClose();
      this.$router.push({
        name: "Partidas pedido",
        params: { idPedido: row.idPedido }
      });
    },
    showDetails(index, row, ref) {
      this.$refs[ref].doClose();
      this.$router.push({
        name: "Detalle pedido",
        params: { idPedido: row.idPedido }
      });
    },
    showTracking(index, row, ref) {
      this.$refs[ref].doClose();
      this.$router.push({
        name: "Tracking pedido",
        params: { idPedido: row.idPedido }
      });
    }
  }
}
</script>

<style scoped>

</style>
